import * as yup from 'yup';

export const validationSchema = yup.object({
  duration: yup
    .number()
    .typeError('Required')
    .required('Required')
    .min(0, 'Duration must be 0 to 999')
    .max(999, 'Duration must be 0 to 999'),
  endDate: yup.date().required('Required'),
  cueRecipient: yup.number().when('isSentCueNote', {
    is: (cueRecipient: any) => cueRecipient,
    then: schema => schema.required('Required'),
    otherwise: null,
  }),
  timeOffRequest: yup.object().shape({
    timeOffRequestReason: yup.string().required('Required'),
    timeOffRequestDetails: yup.array().when('timeOffRequestReason', {
      is: timeOffRequestReason => Number.parseInt(timeOffRequestReason) === 1,
      then: schema => schema.min(1, 'Add at least one timeoff'),
    }),
  }),
});
